export default __webpack_public_path__ + "static/media/Web-Location-page-web.fccd3dc8.jpg";